import { IconButton, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";
import ReplayIcon from "@mui/icons-material/Replay";

import { ActionTooltip } from "../../components/Tooltips";

const Reset = styled("div")(({ theme }: { theme: Theme }) => ({
  color: theme.vars.palette.text.accentInverted,
  marginRight: theme.spacing(1),
  display: "flex",

  "& .MuiButtonBase-root.MuiIconButton-root.Mui-disabled": {
    color: theme.vars.palette.filter.textDisabled,
  },
}));

export const ResetButton = ({
  disabled,
  onClick,
}: {
  disabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <Reset>
      <ActionTooltip title={"RESET"}>
        <IconButton
          color="inherit"
          disabled={disabled}
          onClick={onClick}
          size="small"
        >
          <ReplayIcon fontSize="small" />
        </IconButton>
      </ActionTooltip>
    </Reset>
  );
};
